import {Controller} from "stimulus"
import * as pdfjsLib from 'pdfjs-dist/build/pdf';

export default class extends Controller {
    static targets = [
        "viewer",
        "spinner",
        "pageCount",
        "pageCountWrapper"
    ]

    static values = {
        pdfUrl: String,
        pdfData: String
    }

    connect() {
        const viewer = this.viewerTarget;
        let loadingTask;
        const controllerThis = this;

        if (this.hasPdfDataValue) {
            loadingTask = pdfjsLib.getDocument({data: atob(this.pdfDataValue)});
        } else {
            loadingTask = pdfjsLib.getDocument(this.pdfUrlValue);
        }

        loadingTask.promise.then(function (pdf) {
            for(let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
                const canvas = document.createElement("canvas");
                canvas.className = "w-100";
                viewer.appendChild(canvas);
                controllerThis.renderPage(pdf, canvas, pageNumber)
            }
            controllerThis.spinnerTarget.style.display = 'none';
            if (pdf.numPages > 1) {
                controllerThis.pageCountWrapperTarget.style.display = 'block';
                controllerThis.pageCountTarget.textContent = pdf.numPages;
            }
        });
    }

    renderPage(pdf, canvas, pageNumber) {
        pdf.getPage(pageNumber).then(function (page) {
            const scale = 1.5;
            const viewport = page.getViewport({scale: scale});

            const context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            const renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            page.render(renderContext);
        });
    }
}